import React from 'react';
import { Container } from 'reactstrap';
import Scroll from '../scroll/index';
import './copyright.scss';

function CopyRight() {
    return (
        <div className="footer-wrapper-copytext">
            <Container>
                <div className="footer-copyright-text">
                    <div className="copyright-link">
                        <span>© Copyright 2020 NGT Transformation Services. All Rights Reserved&nbsp;</span>

                        <span> 
                            <a href="/terms">
                                Terms &amp; Conditions
                            </a> /&nbsp;
                            <a href="/cookie">
                                Privacy &amp; Policy
                            </a>
                        </span>
                    </div>
                    <Scroll />
                </div>
            </Container>
        </div>
    );
}

export default CopyRight;

